export default {
  form: `
    group \ 
    bg-white \
    p-4 \
    flex \
    flex-col \
    gap-y-6 \
  `,
  outer: `
    group \
  `,
  inner: `
    relative \
    flex \
    items-center \
    gap-[6px] \
    bg-input \
    border-b \
    border-t-0 \
    border-x-0 \
    border-solid \
    rounded \
    border-input \
    focus-within:border-focus \
    focus-within:ring-2 \
    focus-within:ring-blue-400 \
    p-[10px] \
    group-data-[disabled]:!bg-inactive \
    group-data-[disabled]:!cursor-not-allowed \
  `,
  input: `
    w-full \
    placeholder:!text-placeholder \
    p-0 \
    border-0 \
    bg-input \
    outline-none \
    rounded \
    resize-none \
    group-data-[disabled]:bg-inactive \
    group-data-[disabled]:cursor-not-allowed \
    group-data-[disabled]:opacity-50 \
    text-base \
    leading-snug \
  `,
  icon: `
    w-[24px] \
    h-[24px] \
    shrink-0 \
    self-center \
    flex \
    items-center \
    [&>svg]:shrink-0 \
    [&>svg]:w-full \
  `,
  help: `
    text-xs \
    text-info-medium \
    max-w-prose \
    mt-1 \
  `,
  messages: `
    m-0 \
    p-0 \
    mt-px \
  `,
  message: `
    flex \
    gap-1 \ 
    text-attention-high \
    text-xs \ 
    max-w-prose \
    [&>svg]:shrink-0 \
  `,
}
